export const messages = {
    "shared-link.footer.link.install": "Coba {brandName} secara gratis",
    "shared-link.footer.link.mobile": "{brandName} untuk Seluler",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "Data yang terlindungi",
    "shared-link.password-dialog-box.message": "Silakan tentukan kata sandi untuk mengakses data yang dibagikan",
    "shared-link.password-dialog-box.hint.password": "Kata sandi",
    "shared-link.password-dialog-box.message.invalid-password": "Kata sandi salah",
    "shared-link.form.button.open": "Buka",
    "shared-link.page-not-found.title": "Halaman tidak ditemukan",
    "shared-link.page-not-found.message.main": "Halaman yang Anda cari tidak ditemukan.",
    "shared-link.page-not-found.message.description": "Tautan tersebut mungkin sudah kedaluwarsa, atau bisa jadi Anda telah salah menuliskan alamat.",
    "shared-link.page-not-found.message.error": "Kode kesalahan: 404",
    "shared-link.restore-file.label.size": "Ukuran",
    "shared-link.restore-file.button.restore": "Unduh",
    "shared-link.links-table.column.name": "Nama",
    "shared-link.links-table.column.size": "Ukuran",
    "shared-link.links-table.action.restore": "Unduh",
    "shared-link.links-table.action.restore-all": "Unduh semua",
    "shared-link.side-bar.selected.title:plural": "{count} item dipilih | {count} item dipilih",
    "shared-link.links-table.label.size": "Ukuran",
    "shared-link.links-table.message.empty-folder": "Folder ini kosong"
};
